// const {position} = [{name}, {On field Position}, {off field positon}, {questions about:} {email}]
const president = ["James Danziger", "8 Man", "President", "General Questions", "jdb5@williams.edu"]
const alumniSecretary = ["Amir Estejab", "Prop", "Alumni Secretary", "Alumni Questions", "ahe3@williams.edu"]
const chief = ["Kaan Coffin", "Fly Half", "Chieftan of Protocol", "Miscellaneous Questions", "aaj4@williams.edu"]
// const webmaster = ["RJ Acosta", "Inside Center", "Webmaster", "Out of date website", "rja3@williams.edu"]
const webmaster = ["Matt Laws", "Hooker", "Webmaster", "Website Questions / Bugs", "mdl4@williams.edu"]

const importantPeople = [president, alumniSecretary, chief, webmaster]

export default importantPeople;